import React from 'react';

// Kojiru Logo Mark — Clean "K" in rounded square
export const KutroLogo = ({ size = 48, className = '' }) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 80 80" 
    className={className}
  >
    <rect width="80" height="80" rx="16" fill="#111111"/>
    <text 
      x="40" y="55" 
      textAnchor="middle" 
      fontFamily="'Helvetica Neue', Arial, sans-serif" 
      fontSize="40" 
      fontWeight="200" 
      fill="#ffffff"
      letterSpacing="2"
    >K</text>
  </svg>
);

// Kojiru Logo with text — Concept 6 wordmark
export const KutroLogoFull = ({ size = 40, className = '' }) => (
  <div className={`flex items-center gap-3 ${className}`}>
    <KutroLogo size={size} />
    <div className="flex flex-col">
      <span className="text-lg font-extralight tracking-[0.3em] text-white leading-tight">
        KOJIRU
      </span>
      <span className="text-[8px] tracking-[0.25em] text-gray-500 leading-tight">
        AGENT CREDIT
      </span>
    </div>
  </div>
);

// Slogan
export const KutroSlogan = ({ className = '' }) => (
  <span className={`font-semibold ${className}`}>
    Flat Fee Home Lending. No Surprises.
  </span>
);

export default KutroLogo;
